import TabIndexCapture from "common/helper/TabIndexCapture";

/**
 * This class is responsible for maintaining focus rules on popups. There are two main rules.
 *
 * 1. On "capture", prevent focus from leaving the popup.
 * 2. On "release", move focus to wherever it was before the popup captured focus.
 */
export default class FocusCapture extends TabIndexCapture {

    constructor() {
        super($("#viewport"));
    }

    capture() {
        this._stored = document.activeElement;
        super.capture()
    }

    release() {
        super.release();
        if (this._stored) {
            this._stored.focus();
            delete this._stored;
        }
    }
}
